import { IFourthStageValues } from './FourthStage.types';


export const initialFourthStage: IFourthStageValues = {
  summary: ''
};
